import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=e276bd34&scoped=true"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=e276bd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e276bd34",
  null
  
)

export default component.exports